// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkofajl{border-radius:var(--ds-radius-small,3px)}._16qs1cd0{box-shadow:var(--ds-shadow-overlay,0 8px 9pt #091e4226,0 0 1px #091e424f)}\n._19bv1ejb{padding-left:var(--ds-space-300,24px)}\n._bfhk1j9a{background-color:var(--ds-background-input,#fff)}\n._ca0q1ejb{padding-top:var(--ds-space-300,24px)}\n._n3td1ejb{padding-bottom:var(--ds-space-300,24px)}\n._p12f1mjv{max-width:300px}\n._u5f31ejb{padding-right:var(--ds-space-300,24px)}", ""]);
// Exports
module.exports = exports;
